var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQueuedImages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0067 1.76094C8.04641 2.0928 6.71906 2.93807 5.9623 4.36928C4.60643 6.93355 5.18322 8.81033 4.70906 10.7051C4.2349 12.5999 2.7812 13.2351 1.73564 14.7181C0.919539 15.8757 0.790624 18.6914 2.25314 20.0973C3.70004 21.4772 5.03431 22.7567 7.6321 22.3668C10.2039 21.9926 11.5005 20.2593 14.2024 19.7185C16.9044 19.1777 19.1422 19.6729 20.5801 18.3896C22.0878 17.0439 23.6562 13.322 22.309 10.6356C21.2254 8.47482 18.3123 8.34359 17.0269 6.31824C15.7416 4.29289 15.349 3.14732 14.2946 2.5542C12.8844 1.761 11.6086 1.48975 10.0067 1.76094Z",
    stroke: "#CBA67A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueuedImages);
export default __webpack_public_path__ + "static/media/queued-images.11f4d9b2738f16de75d93f4163a4004c.svg";
export { ForwardRef as ReactComponent };